import { render } from "./ClientEditComponent.vue?vue&type=template&id=a24bffc4"
import script from "./ClientEditComponent.vue?vue&type=script&lang=js"
export * from "./ClientEditComponent.vue?vue&type=script&lang=js"

import "./ClientEditComponent.vue?vue&type=style&index=0&id=a24bffc4&lang=css"

import exportComponent from "C:\\Users\\webencusco\\Desktop\\projects vue3\\flawyer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__